import imgUrlFilter from "../imgUrlFilter"
import { domClientWidth, domPixelRatio } from "../env"

const defineWidth = domClientWidth()
const defineRadio = domPixelRatio()
export const cont_match_img = function(arr, extend, maxWidth) {
    const imgWidth = defineWidth > maxWidth ? maxWidth : defineWidth    

    var than_url_str = "<img"
    var than_url_href,
        than_url_data = " src="
    if (arr[" data-cke-saved-src="]) {
        than_url_href = arr[" data-cke-saved-src="]
        delete arr[" data-cke-saved-src="]
    } else {
        if (arr[" class="] == "lazyload") {
            than_url_data = " data-original="
        }
        than_url_href = arr[than_url_data]
    }
    if (!than_url_href) {
        return ""
    }
    var match_img_width = than_url_href.match(/\/width(\d+)/)
    var match_img_height = than_url_href.match(/\/height(\d+)/)
    match_img_width = match_img_width ? match_img_width[1] : arr[" width="] || 0
    match_img_height = match_img_height ? match_img_height[1] : arr[" height="] || 0

    var rate = Number(arr[" data-rate="]) || 1

    var than_url_href_arr = than_url_href.split("?") // 图片链接
    // var than_url_href_arr = [than_url_href] // 图片链接
    
    var origin_w = match_img_width.toString().indexOf('px') > -1 ? match_img_width.replace("px", "") : match_img_width // 原始宽度
    var origin_h = match_img_height.toString().indexOf('px') > -1 ? match_img_height.replace("px", "") : match_img_height // 原始高度
    // 兼容投票
    if (arr[" id="] && arr[" id="].indexOf('vote_pos') == 0) {

        return `<div id="${arr[" id="]}"></div>`

    } else if (arr[" class="] && arr[" class="].indexOf("long-img-box") > -1) {
        
        // 图片横滑
        arr[than_url_data] = imgUrlFilter(than_url_href, '', 520)
        arr[" height="] = defineWidth * 260 / 375
        extend.forEach(function(val) {
            if (arr[val]) {
                than_url_str += val + '"' + arr[val] + '"'
            }
        })
        return (than_url_str += " >")
    
    } else if (than_url_href.indexOf('.moimg.net') == -1) { 
        //如果链接host不含摩点图片域名，不再替换拼接参数-防止三方链接拼接参数后异常
        arr[than_url_data] = than_url_href;
        
    } else if (than_url_href.indexOf('pure=1') > -1) { 
        // 纯图模式
        arr[" width="] = imgWidth
        arr[" height="] =  origin_h > 0 ? parseInt(origin_h * imgWidth / origin_w) : ''

        arr[than_url_data] = `${imgUrlFilter(
            than_url_href_arr[0],
            parseInt(imgWidth * defineRadio)
        )}`

    } else if (arr[" data-w="]) { // 兼容旧数据
        // arr[" width="] = imgWidth
        let data_w = arr[" width="] || Number(arr[" data-w="].replace('px', ''))
        if (data_w < 690) {
            arr[" width="] = parseInt(data_w / 690 * imgWidth)
            arr[" style="] = arr[" style="] ? "margin: 0 auto;" + arr[" style="] : "margin: 0 auto;"
        } else {
            arr[" width="] = imgWidth
        }
        arr[than_url_data] = `${imgUrlFilter(than_url_href_arr[0], parseInt(imgWidth * defineRadio))}`
        arr[" height="] = ''
        // arr[" width="] = arr[" data-w="]
        // arr[than_url_data] = `${imgUrlFilter(than_url_href_arr[0], parseInt(arr[" data-w="] * defineRadio))}`
    } else {
        if (rate < 1 && arr[" width="] && arr[" width="] < 690 ) { //非纯图-小图

            arr[" height="] = origin_h > 0 ? parseInt(origin_h * rate * imgWidth / origin_w) : ""
            arr[" width="] = parseInt(imgWidth * rate)
            arr[" class="] = arr[" class="] + " img-min"
    
            arr[than_url_data] = `${imgUrlFilter(
                than_url_href_arr[0],
                parseInt(imgWidth * rate * defineRadio)
            )}`
        } else {
            arr[" height="] = origin_h > 0 ? parseInt(origin_h * imgWidth / origin_w) : ''
            arr[" width="] = imgWidth
    
            arr[than_url_data] = `${imgUrlFilter(than_url_href_arr[0], parseInt(imgWidth * defineRadio))}`
        }
    }

    extend.forEach(function(val) {
        if (arr[val]) {
            than_url_str += val + '"' + arr[val] + '"'
        }
    })
    return (than_url_str += " loading='lazy' >")
}